import React from 'react';
import { withRouter } from 'react-router-dom';
// import { useVideoTexture } from '../../hooks';
// import { MediaEvents } from '../../common/media';
// import { DoubleSide } from 'three';

// import vid480 from '../../assets/test/video_720x480_10mb.mp4';
// import vid720 from '../../assets/test/video_1280x720_10mb.mp4';
import Loader from '../../components/xr/loader';

// type ITestRouteProps = {};

const TestRoute = () => {
  // const res480 = useVideoTexture(``);
  // const res720 = useVideoTexture(`video_720`);

  // useEffect(() => {
  //   const handleLoad = () => {
  //     res480.media?.mute();
  //     res480.media?.setLoop(true);
  //     res480.media?.play();
  //   };

  //   res480.media?.on(MediaEvents.Ready, handleLoad);

  //   res480.media?.setResource(vid480);

  //   return () => {
  //     res480.media?.off(MediaEvents.Ready, handleLoad);
  //   };
  // }, [res480.media]);

  // useEffect(() => {
  //   const handleLoad = () => {
  //     res720.media?.mute();
  //     res720.media?.setLoop(true);
  //     res720.media?.play();
  //   };

  //   res720.media?.on(MediaEvents.Ready, handleLoad);

  //   res720.media?.setResource(vid720);

  //   return () => {
  //     res720.media?.off(MediaEvents.Ready, handleLoad);
  //   };
  // }, [res720.media]);

  return (
    <>
      <gridHelper position={[0, -1, 0]} />

      <Loader position={[0, 0, -1]} />

      {/* <group position={[0, 0, -1]}>
        <group position={[-0.6, 0, 0]}>
          <mesh>
            <planeBufferGeometry attach="geometry" args={[0.4, 0.4, 32]} />
            <meshBasicMaterial attach="material" side={DoubleSide}>
              <primitive attach="map" object={res480.texture} />
            </meshBasicMaterial>
          </mesh>
        </group>
        <group position={[0.6, 0, 0]}>
          <mesh>
            <planeBufferGeometry attach="geometry" args={[0.4, 0.4, 32]} />
            <meshBasicMaterial attach="material" side={DoubleSide}>
              <primitive attach="map" object={res720.texture} />
            </meshBasicMaterial>
          </mesh>
        </group>
      </group> */}
    </>
  );
};

export default withRouter(TestRoute);
